import { IInputSpinnerTheme } from '../../models/IInputSpinner';
import { colors } from './colors';

export const inputSpinnerTheme: IInputSpinnerTheme = {
  input: {
    color: colors.neutral.gray,
    borderColor: colors.neutral.transparent,
    fontSize: '16px',
    lineHeight: '16px',
    backgroundColor: colors.neutral.grayLight,
  },
  button: {
    color: colors.neutral.gray,
    borderColor: colors.neutral.lightGray,
    backgroundColor: colors.neutral.lightGray,
  },
  sizes: {
    md: {
      width: '140px',
      height: '40px',
    },
    sm: {
      width: '114px',
      height: '30px',
    },
  },
};
